import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PageSettingStore from '../../app/store/PageSettingStore';
import { isEmpty } from '../../youwell-common/objectUtils';

class LoadOrgConfig extends React.Component {
    componentDidMount() {
        if (this.props.orgId && isEmpty(this.props.orgConfig)) {
            this.props.getOrgConfig(this.props.orgId);
        }
    }

    render() {
        return null;
    }
}

LoadOrgConfig.propTypes = {
    orgId: PropTypes.string,
    orgConfig: PropTypes.object,
    getOrgConfig: PropTypes.func.isRequired,
};

LoadOrgConfig.defaultProps = {
    orgId: null,
    orgConfig: null,
};

const mapStateToProps = (state, ownProps) => ({
    orgId: ownProps.orgId || state.pageSettings.appConfig?.orgId,
    orgConfig: state.pageSettings.orgConfig,
});

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PageSettingStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoadOrgConfig);
